<div class="control-container">
  <div>
    <button
      class="button is-ghost"
      (click)="onOpenTable()">
      <i
        class="icon icon-table_2"
        style="font-weight: 400; color: var(--neutral-color-700); font-size: 24px"></i>
    </button>
  </div>
  <div
    style="position: relative"
    class="mt-4 mb-4">
    <input
      class="input is-small is-iconleft search-control"
      type="text"
      placeholder="{{ 'EDIT-PANEL.FILTER-LIST' | translate }}"
      [formControl]="searchControl"
      style="width: 312px" />
    <i
      class="icon icon-search"
      style="position: absolute; top: 14px; left: 6px; color: var(--neutral-color-400)"></i>
  </div>
</div>
